// Import Component hooks before component definitions
import "./component-hooks";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import { installChunkLoadRecovery } from "./chunkLoadRecovery";
import "./registerServiceWorker";

Vue.config.productionTip = false;

installChunkLoadRecovery();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
